export default __webpack_public_path__ + "static/char-s-33-ko-4c3a8c3fe39b68883d0cef85cfeaf753.webp";